import type { NewcoreIcon } from '@newcore/icons';
import { FingerprintIcon } from '@newcore/icons/icons/fingerprint';
import { KeyIcon } from '@newcore/icons/icons/key';
import { YubikeyIcon } from '@newcore/icons/icons/yubikey';

export enum AuthenticatorFormFactor {
  SECURITY_KEY = 'security_key',
  PLATFORM = 'platform',
  PASSWORD_MANAGER = 'password_manager',
  UNKNOWN = 'unknown',
}

// Deep imports: the barrel re-exports 1200+ modules and slows every consumer.
export const FORM_FACTOR_ICONS: Record<AuthenticatorFormFactor, NewcoreIcon> = {
  [AuthenticatorFormFactor.SECURITY_KEY]: YubikeyIcon,
  [AuthenticatorFormFactor.PLATFORM]: FingerprintIcon,
  [AuthenticatorFormFactor.PASSWORD_MANAGER]: KeyIcon,
  [AuthenticatorFormFactor.UNKNOWN]: FingerprintIcon,
};
